// extracted by mini-css-extract-plugin
export var grid = "styles-module--grid--ZgSPN";